module.exports = __webpack_public_path__ + "static/media/card-payment.c8aedd6a.svg";